import { render } from "./car.vue?vue&type=template&id=2a1f44b6&scoped=true&ts=true"
import script from "./car.vue?vue&type=script&lang=tsx"
export * from "./car.vue?vue&type=script&lang=tsx"

import "./car.vue?vue&type=style&index=0&id=2a1f44b6&lang=less&scoped=true"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1f44b6"]])

export default __exports__